import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHdeHomeDesignEvening = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 225,
	height: 122,
	viewBox: "0 0 225 122",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 121.247V85.3364H28.2776V91.4638H7.79515V99.4996H25.7508V105.476H7.79515V115.169H28.4388V121.247H0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.7788 121.247L28.8227 85.3364H36.9942L43.7679 106.129C44.5205 108.49 45.4344 111.855 45.4344 111.855H45.542C45.542 111.855 46.4559 108.439 47.2085 106.129L53.9285 85.3364H61.8311L48.875 121.247H41.7788Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2914 121.247V85.3364H91.569V91.4638H71.0866V99.4996H89.0423V105.476H71.0866V115.169H91.7303V121.247H63.2914Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.9634 121.247V85.3364H102.866L115.661 105.376C116.897 107.335 118.349 110.398 118.349 110.398H118.456C118.456 110.398 118.241 106.682 118.241 104.17V85.3364H125.929V121.247H118.403L105.285 101.408C104.049 99.4996 102.543 96.4359 102.543 96.4359H102.436C102.436 96.4359 102.651 100.203 102.651 102.714V121.247H94.9634Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.259 121.247V85.3364H138.054V121.247H130.259Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.4 121.247V85.3364H150.303L163.097 105.376C164.334 107.335 165.785 110.398 165.785 110.398H165.893C165.893 110.398 165.678 106.682 165.678 104.17V85.3364H173.365V121.247H165.839L152.722 101.408C151.485 99.4996 149.98 96.4359 149.98 96.4359H149.872C149.872 96.4359 150.087 100.203 150.087 102.714V121.247H142.4Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.812 121.247L205.543 116.425H205.436C202.801 120.543 199.199 122 194.63 122C188.824 122 184.308 120.041 181.136 116.777C177.964 113.462 176.137 108.841 176.137 103.417C176.137 97.4404 178.394 92.2171 182.426 88.7517C185.544 86.0898 189.63 84.6333 194.791 84.6333C204.468 84.6333 210.005 89.6055 211.242 96.6368H203.608C202.747 93.1714 199.898 90.6602 194.952 90.6602C187.695 90.6602 184.093 96.2853 184.093 103.417C184.093 110.75 188.232 116.124 194.845 116.124C200.812 116.124 204.737 111.955 204.737 107.987V107.787H195.49V102.161H211.672V121.247H205.812Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.531 78.5525V71.27H224.38V78.5525H216.531Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.531 121.315V114.032H224.38V121.315H216.531Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.531 36.6814V29.3989H224.38V36.6814H216.531Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.0703 78.4844V42.5742H47.0692C57.3373 42.5742 63.9497 50.3087 63.9497 60.906C63.9497 66.732 61.8531 71.8548 57.8212 75.0189C54.9719 77.2288 51.2625 78.4844 46.4241 78.4844H32.0703ZM39.8655 72.2064H45.8865C53.1978 72.2064 56.0471 68.0378 56.0471 60.906C56.0471 53.7742 52.714 48.802 46.1016 48.802H39.8655V72.2064Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.5773 78.4844V42.5742H94.8548V48.7016H74.3724V56.7374H92.3281V62.714H74.3724V72.4073H95.0161V78.4844H66.5773Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.878 79.2879C102.449 79.2879 96.5352 74.9687 96.2664 67.3849H103.9C104.438 71.7041 107.072 73.4117 112.556 73.4117C116.534 73.4117 120.028 72.1059 120.028 68.7911C120.028 65.2755 116.372 64.5723 110.513 63.3167C103.631 61.8602 97.3416 60.1526 97.3416 52.6692C97.3416 45.5877 103.524 41.9213 112.072 41.9213C120.727 41.9213 126.318 45.889 126.909 53.1213H119.437C119.007 49.5051 115.996 47.6971 112.018 47.6971C107.825 47.6971 105.083 49.3545 105.083 51.9159C105.083 54.8289 107.771 55.6827 113.469 56.8378C121.372 58.445 127.823 60.2028 127.823 67.9373C127.823 75.2198 121.533 79.2879 112.878 79.2879Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.92 78.4844V42.5742H138.715V78.4844H130.92Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.231 78.4844L170.962 73.6629H170.854C168.22 77.7812 164.618 79.2377 160.049 79.2377C154.243 79.2377 149.727 77.279 146.555 74.0144C143.383 70.6997 141.556 66.079 141.556 60.6549C141.556 54.6782 143.813 49.4549 147.845 45.9895C150.963 43.3276 155.049 41.8711 160.21 41.8711C169.887 41.8711 175.424 46.8433 176.661 53.8746H169.027C168.167 50.4092 165.317 47.898 160.371 47.898C153.114 47.898 149.512 53.5231 149.512 60.6549C149.512 67.9876 153.651 73.3615 160.264 73.3615C166.231 73.3615 170.156 69.1929 170.156 65.2252V65.0243H160.909V59.3993H177.091V78.4844H171.231Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.928 78.4844V42.5742H188.83L201.625 62.6136C202.862 64.5723 204.313 67.636 204.313 67.636H204.421C204.421 67.636 204.206 63.9194 204.206 61.4082V42.5742H211.893V78.4844H204.367L191.249 58.6459C190.013 56.7374 188.508 53.6737 188.508 53.6737H188.4C188.4 53.6737 188.615 57.4405 188.615 59.9517V78.4844H180.928Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.5938 36.6133V0.703135H76.3889V14.7658H91.4953V0.703135H99.2905V36.6133H91.4953V20.7927H76.3889V36.6133H68.5938Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.454 37.4169C109.11 37.4169 101.907 29.4815 101.907 18.7335C101.907 7.98561 109.11 0 120.454 0C131.797 0 138.947 7.98561 138.947 18.7335C138.947 29.4815 131.797 37.4169 120.454 37.4169ZM120.507 31.4402C127.55 31.4402 130.991 25.8653 130.991 18.7335C130.991 11.5515 127.55 5.97665 120.507 5.97665C113.465 5.97665 109.863 11.5515 109.863 18.7335C109.863 25.8653 113.465 31.4402 120.507 31.4402Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.598 36.6133V0.703135H152.565L157.994 18.7335C159.338 23.2537 160.413 28.4268 160.413 28.4268H160.521C160.521 28.4268 161.542 23.2537 162.886 18.7335L168.316 0.703135H179.444V36.6133H172.187V16.0214C172.187 13.1085 172.509 8.5883 172.509 8.5883H172.402C172.402 8.5883 171.542 12.8071 170.735 15.4188L164.123 36.6133H156.65L150.199 15.4188C149.393 12.8071 148.533 8.5883 148.533 8.5883H148.425C148.425 8.5883 148.748 13.1085 148.748 16.0214V36.6133H141.598Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.769 36.6133V0.703135H212.047V6.83046H191.565V14.8663H209.52V20.8429H191.565V30.5362H212.208V36.6133H183.769Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgHdeHomeDesignEvening);
export { ForwardRef as ReactComponent };
